export enum ButtonType {
	Search = 'Search',
	OkCancel = 'OkCancel'
}
